import {
  MY_PRODUCTS_ICON,
  MY_PROJECTS_ICON,
  RENDERS_PREVIEWS_ICON,
  ROOMS_ICON,
  PROPS_ICON,
  TEXTURES_ICON,
  COLLECTION_ICON,
  MY_TEAM_ICON,
  SHARED_FILES_ICON,
  CALENDAR_ICON,
  COMMUNITY_ICON,
  SETTINGS_ICON,
  TRASH_ICON,
  PLAY_TO_LEARN_ICON,
  REQUESTS_ICON,
  MY_ACCOUNT_ICON,
  ADD_CREDITS_ICON,
  LOGOUT_ICON,
  QUIT_ICON,
  SUPPORT_ICON,
} from './assetConstants';
import {
  MY_PRODUCTS_ROUTE,
  MY_PROJECTS_ROUTE,
  RENDERS_PREVIEWS_ROUTE,
  TEMPLATES_ROUTE,
  PROPS_ROUTE,
  TEXTURES_ROUTE,
  COLLECTIONS_ROUTE,
  MY_TEAM_ROUTE,
  SHARED_FILES_ROUTE,
  CALENDAR_ROUTE,
  COMMUNITY_ROUTE,
  SETTINGS_ROUTE,
  TRASH_ROUTE,
  PLAY_TO_LEARN_ROUTE,
  REQUESTS_ROUTE,
  MY_ACCOUNT_ROUTE,
  ADD_CREDITS_ROUTE,
  LOGOUT_ROUTE,
  QUIT_ROUTE,
  SUPPORT_ROUTE,
  TUTORIALS_ROUTE,
  AUTOMATION_ROUTE,
  TERMS_OF_USE_ROUTE,
  PRIVACY_POLICY_ROUTE,
  PRODUCT_CONFIGURATORS_ROUTE,
  ADMIN_MY_PRODUCTS_3DMODAL,
  ADMIN_MY_PRODUCTS_ROOMS,
  ADMIN_MY_PRODUCTS_TEXTURE,
  ADMIN_MY_PRODUCTS_UPLOADS,
  TAB,
  PROPS_ROUTE_V2,
  TEMPLATES_ROUTE_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  ADMIN_MY_PRODUCTS_UPLOADS_V2,
  ADMIN_MY_PROJECTS_V2,
  RENDERS_PREVIEWS_ROUTE_V2,
  AUTOMATION_ROUTE_V2,
  PRODUCT_CONFIGURATORS_ROUTE_V2,
  ADMIN_SETTINGS,
  INVITE_INTERNAL_USER,
  AUTOMATION_DETAILS,
  AUTOMATION_EXCEL_HISTORY,
  PRODUCT_CONFIGURATOR_ROUTE,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  NEW_DESIGN_ROUTE,
  SLA_AGREEMENT_ROUTE,
  AI_ROUTE,
  RETAIL_AUTOMATION_ROUTE,
  PRICING_ROUTE,
  PLANS_ROUTE,
  MY_FILES_SHARED_FILES_ROUTE,
  MY_PLANS_ROUTE,
  PRODUCT_BUILDER_ROUTE,
  SHARED_PRODUCT_PAGES_ROUTE_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_MY_PRODUCTS_MATERIAL_V2,
  RETAIL_CONFIGURATOR_ROUTE,
  RETAIL_AUTOMATION_ROUTE_V2,
  ADD_RETAIL_AUTOMATION_ROUTE_V2,
  IMAGINE_AI_ROUTE_V2,
} from '../constants/routePathConstants';
import { icons } from '../assets';
import { PERMISSION } from './permissionConstants';
import {
  ADMIN_DASHBOARD,
  ADMIN_MY_PRODUCTS_TEXTURE_V2,
  CONFIGURATORS_ROUTE,
  CONFIGURATORS_ROUTE_V2,
} from '../config/constant/routePathConstant';
import { MxEvent } from '../common/Mixpanel';
import { MENU_TYPE, SETTINGS_TAB, TUTORIAL_SECTION_OPTIONS } from './constants';
// import ImageAIVideoPopUP from '../screens/AI/ImageAIVideoPopUP';
import {
  DiscordIcon,
  InstagramIcon,
  MyTeamIconV2,
  PrivacyPolicyV2,
  MyPlansIcon,
  ImagineAIV2Icon,
} from '../assets/icons';
import { LIVE_FURNISH } from './projectConstants';
import aiGenerateLottie from '../assets/animations/ai-generate.json';
const {
  MyTeamIcon,
  SharedFilesIcon,
  CalendarIcon,
  CommunityIcon,
  SettingsIcon,
  TrashIcon,
  TrashV2Icon,
  MyFilesIcon,
  TutorialsIcon,
  TutorialsIconV2,
  SupportsIcon,
  RequestsIcon,
  RequestsIconV2,
  TutorialHubIcon,
  MyProductsIcon,
  MyProductsIconV2,
  HomeIcon,
  MyProjectsIcon,
  AutomationIcon,
  MattressBuilderNavIcon,
  RendersPreviewsIcon,
  TemplatesIcon,
  PropsIcon,
  CollectionsIcon,
  MyAccountIcon,
  AddCreditsIcon,
  LogoutIcon,
  PricingIcon,
  FeedbackIcon,
  ConfiguratorsIcon,
  InviteMemberIcon,
  PrivacyPolicy,
  TermAndConditionIcon,
  TermAndConditionIconV2,
  ImagineAIIcon,
  DesignIcon,
  DollarIcon,
  RetailAutomationIconV2,
} = icons;

export const SIDEBAR_MENU = [
  // {
  //   name: 'My team',
  //   icon: MyTeamIcon,
  //   path: MY_TEAM_ROUTE,
  //   mx_event: MxEvent.VISITED_MY_TEAM,
  // },
  {
    name: 'Shared files',
    icon: SharedFilesIcon,
    path: SHARED_FILES_ROUTE,
    mx_event: MxEvent.VISITED_SHARED_FILES,
  },
  // {
  //   name: 'Calendar',
  //   icon: CalendarIcon,
  //   path: CALENDAR_ROUTE,
  // },
  // {
  //   name: 'Community',
  //   icon: CommunityIcon,
  //   path: COMMUNITY_ROUTE,
  // },
  {
    name: 'Settings',
    icon: SettingsIcon,
    path: SETTINGS_ROUTE,
    mx_event: MxEvent.VISITED_SETTINGS,
  },
  {
    name: 'Tutorials',
    icon: TutorialsIcon,
    path: TUTORIALS_ROUTE,
    mx_event: MxEvent.VISITED_TUTORIALS,
  },
  // {
  //   name: 'Play to learn',
  //   icon: PLAY_TO_LEARN_ICON,
  //   path: PLAY_TO_LEARN_ROUTE,
  // },
  {
    name: 'Requests',
    icon: RequestsIconV2,
    path: REQUESTS_ROUTE,
    canGuestUserAccess: true,
  },
];

export const SIDEBAR_MENU_V2 = [
  {
    name: 'Home',
    icon: HomeIcon,
    path: ADMIN_DASHBOARD,
    mx_event: MxEvent.VISITED_DASHBOARD,
  },
  {
    name: 'Products',
    icon: MyProductsIconV2,
    path: ADMIN_MY_PRODUCTS_3DMODAL_V2,
    mx_event: MxEvent.VISITED_MY_MODELS,
    canGuestUserAccess: true,
    isChild: true,
    hoverChildMenu: [
      {
        name: 'Models',
        icon: MyFilesIcon,
        path: ADMIN_MY_PRODUCTS_3DMODAL_V2,
        mx_event: MxEvent.VISITED_MY_MODELS,
        canGuestUserAccess: true,
      },
      {
        name: 'Rooms',
        icon: MyFilesIcon,
        path: ADMIN_MY_PRODUCTS_ROOMS_V2,
        mx_event: MxEvent.VISITED_MY_ROOMS,
      },
      {
        name: 'Textures',
        icon: MyFilesIcon,
        path: ADMIN_MY_PRODUCTS_TEXTURE_V2,
        mx_event: MxEvent.VISITED_MY_TEXTURES,
        canGuestUserAccess: true,
      },
      {
        name: 'Custom Maps',
        icon: MyFilesIcon,
        path: ADMIN_MY_PRODUCTS_UPLOADS_V2,
        mx_event: MxEvent.VISITED_MY_CUSTOM_MAPS,
      },
      {
        name: 'product Modal',
        path: ADMIN_MY_PRODUCTS_3DMODAL_EACH,
      },
      {
        name: 'product Modal',
        path: ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
      },
      {
        name: 'texture module Modal',
        path: ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
      },
      {
        name: 'Materials',
        path: ADMIN_MY_PRODUCTS_MATERIAL_V2,
      },
      {
        name: 'Shared Product Page',
        path: SHARED_PRODUCT_PAGES_ROUTE_V2,
        mx_event: MxEvent.VISITED_SHARED_PRODUCT_PAGES,
      },
    ],
  },
  {
    name: 'Files',
    icon: MyFilesIcon,
    type: 'MY_FILES',
    path: ADMIN_MY_PROJECTS_V2,
    mx_event: MxEvent.VISITED_MY_PROJECTS,
    isChild: true,
    canGuestUserAccess: true,
    hoverChildMenu: [
      {
        name: 'Projects',
        icon: MyProjectsIcon,
        path: ADMIN_MY_PROJECTS_V2,
        mx_event: MxEvent.VISITED_MY_PROJECTS,
        canGuestUserAccess: true,
      },
      {
        name: 'Images',
        icon: RendersPreviewsIcon,
        path: RENDERS_PREVIEWS_ROUTE_V2,
        mx_event: MxEvent.VISITED_IMAGE,
        canGuestUserAccess: true,
      },
      {
        name: 'Automation',
        icon: AutomationIcon,
        path: AUTOMATION_ROUTE_V2,
        // permission: PERMISSION.CAN_CREATE_AUTOMATION,
        mx_event: MxEvent.VISITED_AUTOMATION,
      },
      {
        name: 'automation-details',
        icon: AutomationIcon,
        path: AUTOMATION_DETAILS,
      },
      {
        name: 'automation excel history',
        icon: AutomationIcon,
        path: AUTOMATION_EXCEL_HISTORY,
      },
      {
        name: 'configurator-details',
        icon: AutomationIcon,
        path: PRODUCT_CONFIGURATOR_ROUTE,
      },
      {
        name: 'project modals',
        path: NEW_DESIGN_ROUTE,
      },
      {
        name: 'Configurators',
        icon: ConfiguratorsIcon,
        path: PRODUCT_CONFIGURATORS_ROUTE_V2,
        // permission: PERMISSION.PRODUCT_CONFIGURATORS,
        // mx_event: MxEvent.VISITED_CONFIGURATORS,
      },
      // {
      //   name: 'Retail Automation',
      //   icon: AutomationIcon,
      //   path: RETAIL_AUTOMATION_ROUTE_V2, // RETAIL_AUTOMATION_ROUTE
      // },
      {
        name: 'Configurators',
        icon: ConfiguratorsIcon,
        path: CONFIGURATORS_ROUTE_V2,
      },
      {
        name: 'Imagine AI',
        icon: ImagineAIV2Icon,
        path: IMAGINE_AI_ROUTE_V2,
        mx_event: MxEvent.VISITED_IMAGINE_AI,
      },
      {
        name: 'Shared',
        icon: SharedFilesIcon,
        path: MY_FILES_SHARED_FILES_ROUTE,
      },
    ],
  },

  {
    name: 'Collections',
    icon: CollectionsIcon,
    path: COLLECTIONS_ROUTE,
    mx_event: MxEvent.VISITED_COLLECTIONS,
    isChild: false,
    // hoverChildMenu: [
    //   {
    //     name: 'List',
    //     icon: MyFilesIcon,
    //     path: TRASH_ROUTE,
    //     mx_event: MxEvent.VISITED_TRASH,
    //   },
    //   {
    //     name: 'Details',
    //     icon: MyFilesIcon,
    //     path: TRASH_ROUTE,
    //     mx_event: MxEvent.VISITED_TRASH,
    //   },
    // ],
  },
  {
    name: 'Mattress Builder',
    icon: MattressBuilderNavIcon,
    path: PRODUCT_BUILDER_ROUTE,
    mx_event: MxEvent.VISITED_PRODUCT_BUILDER,
  },
  {
    name: 'Library',
    icon: MyProjectsIcon,
    path: TEMPLATES_ROUTE_V2,
    mx_event: MxEvent.VISITED_TEMPLATES,
    isChild: true,
    hoverChildMenu: [
      {
        name: 'Templates',
        icon: TemplatesIcon,
        path: TEMPLATES_ROUTE_V2,
        mx_event: MxEvent.VISITED_TEMPLATES,
      },
      {
        name: 'Props',
        icon: PropsIcon,
        path: PROPS_ROUTE_V2,
        mx_event: MxEvent.VISITED_PROPS,
      },
    ],
  },
  {
    name: 'Requests',
    icon: RequestsIconV2,
    path: REQUESTS_ROUTE,
    canGuestUserAccess: true,
    mx_event: MxEvent.VISITED_REQUESTS,
  },
  {
    name: 'Retail Automation',
    icon: RetailAutomationIconV2,
    path: RETAIL_CONFIGURATOR_ROUTE,
    mx_event: MxEvent.VISITED_RETAIL_CONFIGURATOR,
    permission: PERMISSION.RETAIL_AUTOMATION,
    /*
      Both of this item's tabs listed, the way Library lists Templates and Props.
      The active check falls back to `pathname.includes(item.path)`, and `path` is
      only the Create Content tab - so Create Template, living under
      /retail/automation, left the parent unhighlighted. Listed here, either tab
      matches. No dropdown comes with this; the hover menu is commented out.
    */
    isChild: true,
    hoverChildMenu: [
      {
        name: 'Create Content',
        icon: RetailAutomationIconV2,
        path: RETAIL_CONFIGURATOR_ROUTE,
        mx_event: MxEvent.VISITED_RETAIL_CONFIGURATOR,
      },
      {
        name: 'Create Template',
        icon: RetailAutomationIconV2,
        path: RETAIL_AUTOMATION_ROUTE_V2,
        mx_event: MxEvent.VISITED_RETAIL_AUTOMATION,
      },
      // Detail pages, so opening one keeps the parent lit.
      { name: 'New Automation', path: ADD_RETAIL_AUTOMATION_ROUTE_V2 },
      { name: 'Automation Details', path: '/retail/automation/:automationId' },
    ],
  },
  {
    name: 'AI Studio',
    icon: ImagineAIV2Icon,
    path: AI_ROUTE,
    canGuestUserAccess: true,
    // Same `Clicked - AI Studio` the dashboard's "Go to AI Studio" link sends; only
    // `click_from` (added by the side menu) tells the two doors apart.
    mx_event: MxEvent.CLICKED_AI_STUDIO,
    newTab: true,
    hasLottie: aiGenerateLottie,
  },
  // {
  //   name: 'Workflow',
  //   icon: ImagineAIV2Icon,
  //   path: WORKFLOW_BUILDER_ROUTE,
  //   canGuestUserAccess: true,
  //   mx_event: MxEvent.CLICK_WORKFLOW_BUILDER,
  //   newTab: true,
  //   // Show only when the user has the WORKFLOW_BUILDER permission (canUseWorkflowBuilder).
  //   requiresCanUseWorkflowBuilder: true,
  // },
  {
    name: 'Tutorials',
    icon: TutorialsIconV2,
    path: `${TUTORIALS_ROUTE}?activeSection=${TUTORIAL_SECTION_OPTIONS.HOME}`,
    mx_event: MxEvent.VISITED_TUTORIALS,
  },
  // {
  //   name: 'Retail Configurator',
  //   icon: TutorialsIconV2, // TODO: Changes icon
  //   path: RETAIL_CONFIGURATOR_ROUTE,
  //   mx_event: MxEvent.VISITED_RETAIL_CONFIGURATOR,
  // },
  // {
  //   name: 'Shared files',
  //   icon: SharedFilesIcon,
  //   path: `${SHARED_FILES_ROUTE}?filterOrder=shared`,
  //   mx_event: MxEvent.VISITED_SHARED_FILES,
  //   isChild: true,
  //   hoverChildMenu: [
  //     {
  //       name: 'Shared files',
  //       icon: SharedFilesIcon,
  //       path: SHARED_FILES_ROUTE,
  //       mx_event: MxEvent.VISITED_SHARED_FILES,
  //     },
  //   ],
  // },
  // {
  //   name: 'Imagine AI',
  //   icon: ImagineAIIcon,
  //   mx_event: MxEvent.IMAGINE_AI_CLICKED,
  //   path: AI_ROUTE,
  //   isNew: true,
  //   hoverComponent: ImageAIVideoPopUP,
  //   target: '_blank',
  // },
  // {
  //   name: 'Tab UI',
  //   icon: SharedFilesIcon,
  //   path: TAB,
  //   mx_event: MxEvent.VISITED_SHARED_FILES,
  // },
];

export const GUEST_USER_SIDEBAR_MENU = [
  {
    name: 'My Files',
    icon: MyFilesIcon,
    type: 'MY_FILES',
    path: ADMIN_MY_PROJECTS_V2,
    mx_event: MxEvent.VISITED_MY_PROJECTS,
    isChild: true,
    canGuestUserAccess: true,
    hoverChildMenu: [
      {
        name: 'Projects',
        icon: MyProjectsIcon,
        path: ADMIN_MY_PROJECTS_V2,
        mx_event: MxEvent.VISITED_MY_PROJECTS,
        canGuestUserAccess: true,
      },
      {
        name: 'Images',
        icon: RendersPreviewsIcon,
        path: RENDERS_PREVIEWS_ROUTE_V2,
        mx_event: MxEvent.VISITED_IMAGE,
        canGuestUserAccess: true,
      },
    ],
  },
  {
    name: 'Library',
    icon: MyProjectsIcon,
    path: TEMPLATES_ROUTE_V2,
    mx_event: MxEvent.VISITED_TEMPLATES,
    isChild: true,
    hoverChildMenu: [
      {
        name: 'Templates',
        icon: TemplatesIcon,
        path: TEMPLATES_ROUTE_V2,
        mx_event: MxEvent.VISITED_TEMPLATES,
      },
      {
        name: 'Props',
        icon: PropsIcon,
        path: PROPS_ROUTE_V2,
        mx_event: MxEvent.VISITED_PROPS,
      },
    ],
  },
  {
    name: 'Tutorial Hub',
    icon: TutorialHubIcon,
    path: `${TUTORIALS_ROUTE}?activeSection=${TUTORIAL_SECTION_OPTIONS.HOME}`,
    mx_event: MxEvent.VISITED_TUTORIALS,
  },
];

export const SIDEBAR_MENU_V2_2 = [
  {
    name: 'My team',
    icon: MyTeamIconV2,
    path: `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.MEMBERS}`,
  },
  {
    name: 'Plans',
    icon: DollarIcon,
    path: PLANS_ROUTE,
  },
  {
    name: 'Settings',
    icon: SettingsIcon,
    path: `${ADMIN_SETTINGS}?activeTab=${SETTINGS_TAB.DETAILS}`,
    canGuestUserAccess: true,
  },
  // {
  //   name: 'Requests',
  //   icon: RequestsIconV2,
  //   path: REQUESTS_ROUTE,
  //   canGuestUserAccess: true,
  //   mx_event: MxEvent.VISITED_REQUESTS,
  // },
  {
    name: 'Privacy Policy',
    icon: PrivacyPolicyV2,
    path: LIVE_FURNISH.privacyPolicy, // PRIVACY_POLICY_ROUTE,
    target: '_blank',
    canGuestUserAccess: true,
    newTab: true,
  },
  // {
  //   name: 'Support',
  //   icon: FeedbackIcon,
  //   path: SUPPORT_ROUTE,
  //   target: '_blank',
  //   canGuestUserAccess: true,
  // },
  {
    key: MENU_TYPE.CONTACT_SUPPORT_FORM,
    icon: FeedbackIcon,
    name: 'Support',
    mx_event: MxEvent.OPENED_CONTACT_SUPPORT_FORM,
    canGuestUserAccess: true,
    canAccessPackUser: true,
  },
  {
    name: 'SLA Agreement',
    icon: TermAndConditionIcon,
    path: SLA_AGREEMENT_ROUTE,
    target: '_blank',
    canGuestUserAccess: true,
    canAccessPackUser: true,
  },
  {
    name: 'Terms of Use',
    icon: TermAndConditionIconV2,
    path: LIVE_FURNISH.termsOfUse, // TERMS_OF_USE_ROUTE,
    target: '_blank',
    canGuestUserAccess: true,
    newTab: true,
  },
  {
    key: MENU_TYPE.LOGOUT,
    name: 'Log out',
    icon: LogoutIcon,
    canGuestUserAccess: true,
  },
];

export const SIDEBAR_MENU_2 = [
  // { {/* Remove for beta */}
  //   name: 'Support',
  //   icon: SupportsIcon,
  //   path: SUPPORT_ROUTE,
  // },
  // {
  //   key: MENU_TYPE.FEEDBACK,
  //   icon: FeedbackIcon,
  //   name: 'Feedback',
  //   mx_event: MxEvent.OPENED_FEEDBACK_FORM,
  //   canGuestUserAccess: true,
  // },
  // {
  //   key: MENU_TYPE.MY_PLANS,
  //   icon: MyPlansIcon,
  //   name: 'My Plans',
  //   path: MY_PLANS_ROUTE,
  //   mx_event: MxEvent.VISITED_MY_PLANS,
  // },
  {
    key: MENU_TYPE.JOIN_DISCORD,
    icon: DiscordIcon,
    name: 'Join Discord',
    mx_event: MxEvent.JOIN_DISCORD,
  },
  {
    key: MENU_TYPE.JOIN_INSTAGRAM,
    icon: InstagramIcon,
    name: 'Join Instagram',
    mx_event: MxEvent.JOIN_INSTAGRAM,
  },
  // {
  //   key: MENU_TYPE.CONTACT_SUPPORT_FORM,
  //   icon: FeedbackIcon,
  //   name: 'Contact Support',
  //   mx_event: MxEvent.OPENED_CONTACT_SUPPORT_FORM,
  //   canGuestUserAccess: true,
  //   canAccessPackUser: true,
  // },
  //   icon: PricingIcon,
  //   name: 'Pricing',
  //   path: PRICING_ROUTE,
  //   mx_event: MxEvent.VISITED_PRICING,
  // },
  {
    name: 'Trash',
    icon: TrashV2Icon,
    path: TRASH_ROUTE,
    mx_event: MxEvent.VISITED_TRASH,
  },
];

export const SIDEBAR_MENU_3 = [
  {
    name: 'Terms of use',
    path: LIVE_FURNISH.termsOfUse, // TERMS_OF_USE_ROUTE,
    target: '_blank',
    mx_event: MxEvent.VISITED_TERMS_OF_USE,
    canGuestUserAccess: true,
    newTab: true,
  },
  {
    name: 'Privacy policy',
    path: LIVE_FURNISH.privacyPolicy, // PRIVACY_POLICY_ROUTE,
    target: '_blank',
    mx_event: MxEvent.VISITED_PRIVACY_POLICY,
    canGuestUserAccess: true,
    newTab: true,
  },
  {
    name: 'SLA Agreement',
    path: SLA_AGREEMENT_ROUTE,
    target: '_blank',
    mx_event: MxEvent.VISITED_SLA_AGREEMENT,
    canGuestUserAccess: true,
  },
];

export const MAIN_MENU = [
  {
    name: 'Home',
    icon: HomeIcon,
    path: ADMIN_DASHBOARD,
    mx_event: MxEvent.VISITED_DASHBOARD,
  },
  {
    name: 'My Products',
    icon: MyProductsIconV2,
    path: MY_PRODUCTS_ROUTE,
    mx_event: MxEvent.VISITED_MY_PRODUCTS,
  },
  {
    name: 'My Projects',
    icon: MyProjectsIcon,
    path: MY_PROJECTS_ROUTE,
    mx_event: MxEvent.VISITED_MY_PROJECTS,
    canGuestUserAccess: true,
  },
  {
    name: 'Configurators',
    icon: ConfiguratorsIcon,
    path: PRODUCT_CONFIGURATORS_ROUTE,
    permission: PERMISSION.PRODUCT_CONFIGURATORS,
  },
  {
    name: 'Automation',
    icon: AutomationIcon,
    path: AUTOMATION_ROUTE,
    permission: PERMISSION.CAN_CREATE_AUTOMATION,
    mx_event: MxEvent.VISITED_AUTOMATION,
  },
  {
    name: 'Images',
    icon: RendersPreviewsIcon,
    path: RENDERS_PREVIEWS_ROUTE,
    mx_event: MxEvent.VISITED_IMAGE,
    canGuestUserAccess: true,
  },
  {
    name: 'Templates',
    icon: TemplatesIcon,
    path: TEMPLATES_ROUTE,
    mx_event: MxEvent.VISITED_TEMPLATES,
  },
  {
    name: 'Props',
    icon: PropsIcon,
    path: PROPS_ROUTE,
    mx_event: MxEvent.VISITED_PROPS,
  },
  {
    name: 'Collections',
    icon: CollectionsIcon,
    path: COLLECTIONS_ROUTE,
    mx_event: MxEvent.VISITED_COLLECTIONS,
  },
  {
    name: 'Configurators',
    icon: ConfiguratorsIcon,
    path: CONFIGURATORS_ROUTE,
    permission: PERMISSION.CONFIGURATORS,
  },
];

export const USER_MENU = [
  {
    name: 'My account',
    icon: SettingsIcon,
    path: SETTINGS_ROUTE,
  },
  // {
  //   name: 'Add credits',
  //   icon: AddCreditsIcon,
  //   path: ADD_CREDITS_ROUTE,
  //   permission: PERMISSION.PURCHASE_CREDIT,
  // },
  {
    key: MENU_TYPE.LOGOUT,
    name: 'Log out',
    icon: LogoutIcon,
    canGuestUserAccess: true,
  },
  // {
  //     name: "Quit",   // commenting because of no use in lfv2
  //     icon: QUIT_ICON,
  //     path: QUIT_ROUTE
  // }
];
